import { Coordinate } from "ol/coordinate";

export const featureGroup: Array<Array<Coordinate>> = [];
